import SEO from "@/common/components/seo";
import FadeIn from "@/common/components/fade-in";
import { useEffect } from "react";
import { trackViewContent } from "@/common/services/analytics";
import GiveawayDetailsHeader from "../components/giveaway-details-header";
import GetOneOffEntries from "../containers/entries";
import FrequentlyAskedQuestions from "../containers/faqs";
import GiveawayDetails from "../containers/giveaway-details";
import JoinTheClub from "../containers/join-the-club";
import KeyFeaturesAndSpecifications from "../containers/key-features";
import PreviousWinners from "../containers/previous-winners";
import useGiveawayDetails from "../hooks/use-giveaway-details";

function GiveawayDetailsPage() {
	const { currentGiveaway } = useGiveawayDetails();

	useEffect(() => {
		if (!currentGiveaway) return;
		trackViewContent({
			content_type: "product",
			content_name: currentGiveaway.prize.title,
			content_ids: [`giveaway_${currentGiveaway.id}`],
		});
	}, [currentGiveaway]);

	const renderEntriesAndMembership = () => {
		if (currentGiveaway?.type === "weekly") {
			return (
				<>
					<div id="join-the-club">
						<JoinTheClub />
					</div>
					<GetOneOffEntries />
				</>
			);
		} else {
			return (
				<>
					<div id="join-the-club">
						<JoinTheClub />
					</div>
					<GetOneOffEntries />
				</>
			);
		}
	};

	return currentGiveaway ? (
		<div>
			<SEO
				title={`${currentGiveaway.prize.title} - Reel Rewards`}
				description={currentGiveaway.prize.description}
				image={currentGiveaway.prize.images[0]?.url}
			/>
			<GiveawayDetailsHeader promotion={currentGiveaway} />
			<FadeIn>{renderEntriesAndMembership()}</FadeIn>
			<FadeIn>
				<KeyFeaturesAndSpecifications promotion={currentGiveaway} />
			</FadeIn>
			<FadeIn>
				<PreviousWinners />
			</FadeIn>
			<FadeIn>
				<GiveawayDetails promotion={currentGiveaway} />
			</FadeIn>
			<FadeIn>
				<FrequentlyAskedQuestions />
			</FadeIn>
		</div>
	) : (
		<div></div>
	);
}

export default GiveawayDetailsPage;
